import EventsIcon from '@material-ui/icons/CalendarTodayRounded';
import EventsList from './CalendarPanel';

const CalendarPanelModule = {
    icon: EventsIcon,
    list: EventsList,
}; export default CalendarPanelModule;